
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class Paragraph extends Vue {
  @Prop({ default: "default" }) variant: string;
  @Prop({ default: "default" }) color: string;
}
